import { RootState } from "../StoreHooks";

export const getRoleFilters = (state: RootState) => {
  const { roleFilters } = state.roleFilters || {};

  return [...roleFilters];
};
